import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m12.487 19.588-4.513-.082c-1.462-.029-2.927.028-4.36-.27-2.179-.445-2.333-2.628-2.495-4.46a31.284 31.284 0 0 1 .284-7.748c.237-1.433 1.17-2.287 2.614-2.38 4.872-.338 9.777-.298 14.64-.14.513.014 1.03.093 1.536.183 2.5.438 2.56 2.912 2.722 4.994.162 2.105.094 4.22-.215 6.31-.248 1.73-.722 3.18-2.722 3.32-2.507.184-4.956.331-7.47.284.001-.01-.013-.01-.02-.01Zm-2.653-4.38c1.889-1.085 3.741-2.151 5.62-3.228-1.893-1.085-3.742-2.151-5.62-3.228v6.456Z" }, null, -1)
  ])))
}
export default { render: render }